import { logger } from "../helpers/logger.qwik.mjs";
function logFetch(url) {
  var _a;
  if (typeof process !== "undefined" && ((_a = process.env) == null ? void 0 : _a.DEBUG)) {
    if (String(process.env.DEBUG) == "true")
      logger.log(url);
  }
}
export {
  logFetch
};
